<template>
  <div class="card-aspect-ratio" @click="handleClick">
    <div
      class="card"
      :class="{
        correct: showCorrect,
        incorrect: showIncorrect,
        dimmed: isDimmed,
        'pronunciation-card': isPronunciation,
      }"
      ref="card"
    >
      <div class="card-inner">
        <!-- Front side - normal card view -->
        <div class="card-front">
          <div
            v-if="!isPronunciation && img"
            class="card-back-image"
            :style="cardBackgroundUrlStyle"
          ></div>
          <div v-if="!isPronunciation" class="card-text-front">{{ text }}</div>
          <div
            v-if="isPronunciation"
            class="card-text-front pronunciation-text"
          >
            {{ text }}
          </div>
          <transition name="fade">
            <div v-if="showCorrect" class="overlay correct-overlay">
              <svg viewBox="0 0 24 24" class="icon check-icon">
                <path
                  d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                />
              </svg>
            </div>
          </transition>
          <transition name="fade">
            <div v-if="showIncorrect" class="overlay incorrect-overlay">
              <svg viewBox="0 0 24 24" class="icon cross-icon">
                <path
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                />
              </svg>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OddOneOutCard',
  props: {
    text: String,
    img: String,
    showCorrect: Boolean,
    showIncorrect: Boolean,
    isPronunciation: Boolean,
    isDimmed: Boolean,
  },
  computed: {
    cardBackgroundUrlStyle() {
      if (!this.img) return {}
      return {
        backgroundImage: `url(${this.img})`,
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.card-aspect-ratio {
  width: 100%;
  padding-top: 100%;
  position: relative;
  cursor: pointer;
}

.card {
  background-color: transparent;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  perspective: 1000px;
  transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.card.dimmed .card-inner {
  position: relative;
}

.card.dimmed .card-inner::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  pointer-events: none;
  transition: background-color 0.8s ease;
}

.card-front,
.card-expanded {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.card-front {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: var(--secondary-green);
  padding-bottom: 0.5rem;
}

.card-back-image {
  width: 100%;
  flex: 1;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.card-text-front {
  font-size: 1.2rem;
  color: var(--almost-black);
  font-weight: bold;
  padding: 0.5rem;
  text-align: center;
  width: 100%;
}

.card-text-front.pronunciation-text {
  font-size: 2rem;
  padding: 1rem;
  background-color: transparent;
}

.pronunciation-card .card-front {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.correct-overlay {
  background: rgba(16, 185, 129, 0.95);
}

.incorrect-overlay {
  background: rgba(239, 68, 68, 0.95);
}

.icon {
  width: 70px;
  height: 70px;
  fill: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .card-text-front {
    font-size: 1.25rem;
  }

  .pronunciation-card .card-text-front {
    font-size: 1.75rem;
  }

  .icon {
    width: 60px;
    height: 60px;
  }
}
</style>
